<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openParkpassruleAddShow"
          >新 增
        </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkpassrule_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          @click="openInspectplanViewDialog(scope.row)"
          >查看
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          @click="openInspectplanEditDialog(scope.row)"
          >编辑
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="新增"
      :visible.sync="parkpassruleAddShow"
      :modal-append-to-body="false"
      @close="quitInspectplanAddDialog"
      size="70%"
    >
      <div class="el-dialog-div">
        <parkpassrule-form
          ref="parkpassruleAdd"
          :parkpassruleAddFrom="parkpassruleAddFrom"
          @submit="rowSave"
          :disabled="false"
        >
        </parkpassrule-form>
      </div>
    </el-dialog>
    <el-dialog
      title="查看"
      :visible.sync="parkpassruleViewShow"
      :modal-append-to-body="false"
      @close="quitInspectplanAddDialog"
      size="70%"
    >
      <div class="el-dialog-div">
        <parkpassrule-form
          ref="parkpassruleView"
          :parkpassruleAddFrom="parkpassruleViewFrom"
          :disabled="true"
        >
        </parkpassrule-form>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="parkpassruleEditShow"
      :modal-append-to-body="false"
      @close="quitInspectplanAddDialog"
      size="70%"
    >
      <div class="el-dialog-div">
        <parkpassrule-form
          ref="parkpassruleEdit"
          :parkpassruleAddFrom="parkpassruleEditFrom"
          @submit="rowUpdate"
          :disabled="false"
          :edit="true"
        >
        </parkpassrule-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/park/pass/parkpassrule';
import { mapGetters } from 'vuex';
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import parkpassruleForm from './parkpassrule-form.vue';
export default {
  components: {
    'parkpassrule-form': parkpassruleForm,
  },
  data() {
    return {
      parkpassruleAddFrom: {},
      parkpassruleEditFrom: {},
      parkpassruleViewFrom: {},
      parkpassruleViewShow: false,
      parkpassruleEditShow: false,
      parkpassruleAddShow: false,
      activeName: 'in',
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      reWrite: false,
      spaceList: [],
      tempParkingLotId: '',
      firstDisplayFlag: false,

      option: {
        height: 'auto',
        //calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        // delBtn: false,
        selection: false,
        dialogClickModal: false,
        labelWidth: 130,
        align: 'center',
        indexLabel: '序号',
        dialogWidth: '40%',
        refreshBtn:false,
        span: 24,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'select',
            editDisabled: true,
            search: true,
            maxlength: 32,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '规则名称',
            prop: 'ruleName',
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入规则名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '规则编号',
            prop: 'ruleCode',
            maxlength: 16,
            rules: [
              {
                required: true,
                message: '请输入规则编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出入类型',
            prop: 'passageType',
            type: 'select',
            dicData: [
              { label: '入口规则', value: 1 },
              { label: '出口规则', value: 2 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择出入类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '规则数据(json)',
            prop: 'ruleData',
            hide: true,
            type: 'textarea',
            minRows: 2,
            overHidden: true,
            //display: false,
            rules: [
              {
                required: true,
                message: '请输入规则数据:json数据',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            minRows: 2,
            maxlength: 128,
            overHidden: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkpassrule_add, false),
        viewBtn: this.vaildData(this.permission.parkpassrule_view, false),
        delBtn: this.vaildData(this.permission.parkpassrule_delete, false),
        editBtn: this.vaildData(this.permission.parkpassrule_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        spaceColumn.searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.tempParkingLotId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  methods: {
    // 打开新增弹窗
    openParkpassruleAddShow() {
      this.parkpassruleAddShow = true;
    },
    quitInspectplanAddDialog() {
      this.parkpassruleAddFrom = {};
      this.parkpassruleAddFrom.passageType = 1;
    },
    // 打开查看弹窗
    openInspectplanViewDialog(data) {
      this.parkpassruleViewShow = true;
      this.parkpassruleViewFrom = data;
      setTimeout(() => {
        this.$refs.parkpassruleView.showData(data);
      }, 0);
    },
    // 打开编辑弹窗
    openInspectplanEditDialog(data) {
      this.parkpassruleEditShow = true;
      this.parkpassruleEditFrom = data;
      setTimeout(() => {
        this.$refs.parkpassruleEdit.showData(data);
      }, 0);
    },
    rowSave(row, done, loading) {
      add(this.parkpassruleAddFrom).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.parkpassruleAddShow = false;
          this.parkpassruleAddFrom = {};
          this.parkpassruleAddFromm.passageType = 1;
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(this.parkpassruleEditFrom).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.parkpassruleEditShow = false;
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时parkingLotId为空，则将parkingLotId置为当前的第一个车场
      if (this.query.parkingLotId == undefined || this.query.parkingLotId == '') {
        this.query.parkingLotId = this.tempParkingLotId;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="车场名称"]');
            ent.value = this.spaceList[0].title;
            this.query.parkingLotId = this.spaceList[0].id;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        }
      );
    },
  },
};
</script>

<style></style>
